module.exports = __webpack_public_path__ + "static/img/validator_icon.788e769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/validator/validator_icon.png
// module id = Q+qx
// module chunks = 1